import React from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useProductWizardContext } from 'state/product-wizard-v2';
import useProductWizardFlow from 'state/product-wizard-v2/hooks/use-product-wizard-flow';
import { ProductWizardStep } from 'state/product-wizard-v2/types';

import { logCTAEvent } from '../../utils';
import { BodyComponent } from '../body-component';

export const CloseConfirmationDialog = () => {
  const { formatMessage } = useIntl();
  const { goBack } = useNavigation();

  const { showCloseDialog, handleCloseDialog } = useProductWizardContext();
  const { currentStep } = useProductWizardFlow();
  const heading = formatMessage({ id: 'productDetailCloseHeading' });
  const content = formatMessage({ id: 'productDetailCloseContent' });

  const confirmLabel = formatMessage({ id: 'leaveNow' });
  const cancelLabel = formatMessage({ id: 'continueCustomizing' });
  const shouldShowDialog = showCloseDialog && currentStep !== ProductWizardStep.ProductHome;

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Product Detail Close Dialog"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={() => {
        logCTAEvent(confirmLabel);
        goBack();
      }}
      onCancel={() => {
        logCTAEvent(cancelLabel);
        handleCloseDialog(false);
      }}
    />
  );
};
